import { Injectable } from '@angular/core';
import { ValidationStateService } from '@r1-compass-library/features/validation-sync';
import { ContentLibrarySectionName } from '@r1-compass-library/features/validation-sync';
import { AppConstants } from '../app.constants';

@Injectable({
    providedIn: 'root',
})
export class ContentLibraryValidationStateService extends ValidationStateService<ContentLibrarySectionName> {
    constructor() {
        super(AppConstants.ContentLibraryComponent.children);
    }
}
